export class SoggettoGiuridico{
    id:number;
    denominazione:string;
    codiceIpa:string;
    codiceIdentificativo:string;
    siglaProvincia:string;   
    ruolo:string;
    ruoloId:string; 
}